export default {
  Received: 'Received',
  Approved: 'Approved',
  Rejected: 'Rejected',
  ToReview: 'ToReview',
  Processing: 'Processing',
  Removed: 'Removed',
  Corrected: 'Corrected',
  Processed: 'Processed',
  Modified: 'Modified',
  RemovedForCorrection: 'RemovedForCorrection'
};
